/**
 * @todo
 * Builder check should be done by url query builder param.
 */
export const isBuilder = (() => {
    try {
        return window && window.parent && window.parent.location.pathname === '/nga_builder';
    } catch (e) {
        return false;
    }
})();
